import { type ChangeEvent, type FocusEvent, useEffect, useState } from "react";

export default function useNumberSpinner(
  value: number,
  setValue: (newValue: number) => void,
  minValue: number,
  maxValue: number,
) {
  const [inputValue, setInputValue] = useState(value.toString());

  useEffect(() => {
    setInputValue(value.toString());
  }, [value]);

  function updateValue(value: number) {
    const clamped = Math.max(minValue, Math.min(value, maxValue));
    setValue(clamped);
  }

  const inputProps = {
    type: "number",
    value: inputValue,
    maxLength: 4,
    onChange: (e: ChangeEvent<HTMLInputElement>) => {
      const { value } = e.currentTarget;

      const numericValue = Number(value);
      if (!Number.isNaN(numericValue)) {
        updateValue(numericValue);
      }
    },
    onBlur: (e: FocusEvent<HTMLInputElement>) => {
      const { value } = e.currentTarget;

      const numericValue = Number(value);
      if (!Number.isNaN(numericValue)) {
        updateValue(numericValue);
      }
    },
  };
  const decrementButtonProps = {
    onClick: () => updateValue(value - 1),
    disabled: value <= minValue,
    ariaLabel: "decrement value",
  };
  const incrementButtonProps = {
    onClick: () => updateValue(value + 1),
    disabled: value >= maxValue,
    ariaLabel: "increment value",
  };
  return { inputProps, decrementButtonProps, incrementButtonProps };
}
